import React from "react";
import axios from "axios";
import { setup as URI_SETUP } from "../../../../config/api";
import { Icon, notification, Modal } from 'antd';

const uri_users = URI_SETUP+"users_total";
const uri_modules = URI_SETUP+"contracted_module";
const uri_refresh = URI_SETUP+"refreshUsers";
const { confirm } = Modal;
class Roles extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            users         : [],
            total_user    : 0,
            used_users    : 0,
            add_user_enable : "hide",
            showUsers     : "hide",
            showLoadingUsers: "",
            showLoadingData : "",
            showData      : "hide"
        }
    }

    componentDidMount(){
        this.getTotalUsers();
        this.handleDataLoaded();
        this.veryfyNotifications();
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.business_id != this.props.business_id) {
            this.getTotalUsers();
            this.getModules();
        }
        if (prevProps.loading_users != this.props.loading_users) {
            this.handleDataLoaded();
        }
    }

    veryfyNotifications(){
        if(this.props.show_user_edited_notification){
            notification.open({
                message: 'NOTIFICATION',
                description: 'User information was successfully edited',
              });
            
            this.props.setUserEditedNotification(false);
        }
        if(this.props.show_user_added_notification){
            notification.open({
                message: 'NOTIFICATION',
                description: 'User was successfully added',
              });
            
            this.props.setUserAddedNotification(false);
        }
    }

    handleDataLoaded(){
        let self = this;
        if(this.props.loading_users){
            self.setState({
                showLoadingData : "",
                showData      : "hide"
            })
        }else{
            self.setState({
                showLoadingData : "hide",
                showData      : ""
            })
        }
    }

    getModules(){
        let self = this;
        var qs = require("qs");
        const dataToSent = qs.stringify({
            api_token   : localStorage.getItem("api_token"),
            business_id : self.props.business_id,
        });
        axios.post(uri_modules, dataToSent)
                .then(request => { 
                    //console.log(request.data);
                })
    }

    getTotalUsers(){
        let self = this;

        axios.get(uri_users, { 
            params: {
                api_token   : localStorage.getItem("api_token"),
                business_id : self.props.business_id
            }
        }).then(request => { 
                if(request.data["status"]== "success"){
                    if(request.data["total_users"]>0){
                        self.setState({
                            total_user: request.data["total_users"],
                            used_users: request.data["used_users"],
                            showLoadingUsers : "hide",
                            showUsers : "show"
                        })
                        if( self.state.used_users > 0){
                            self.setState({
                                add_user_enable : ""
                            })
                        }
                    }
                }
            })
    }

    handleEditUser(user_id){
        this.props.setEditingUser(user_id);
        this.props.activeSection("setup","adduser","","");
    }
    
    handleRefresUsers(){
        let self = this;
        confirm({
            title: 'Do you want to run data update?',
            content: (
                <div>
                  <p>This process may take several minutes.</p>
                  <p>The data with unparsed values could’t be visible, please confirm all the new data was correctly parsed.</p>
                </div>
              ),
            onOk() {
                var qs = require("qs");
                const dataToSent = qs.stringify({
                    api_token   : localStorage.getItem("api_token"),
                    business_id : self.props.business_id,
                });
                axios.post(uri_refresh, dataToSent)
                    .then(request => { 
                        console.log(request.data);
                        if(request.data.status == 'success'){
                            notification.open({
                                message: 'NOTIFICATION',
                                description: 'User data will be updated',
                            });
                        }
                    })
            },
            onCancel() {
                console.log('Cancel');
            },
        });
        
    }

    renderUsers(){
        let self = this;
        return  Object.keys(self.props.users).map((key, index) => {
            if(self.props.users[key].modules == null){
                self.props.users[key].modules = [];
            }
            return(
                <tr key={self.props.users[key]._id}>
                    <td>{self.props.users[key].name + " " + self.props.users[key].lastname }</td>  
                    <td>Included</td>
                    <td>
                    {Object.keys(self.props.roles).map((keyrole, index) => {
                        if(self.props.roles[keyrole]._id === self.props.users[key].sys_roll_id)
                        return (self.props.roles[keyrole].name);
                    })}
                    </td>
                    <td>
                        {Object.keys(self.props.users[key].modules).map((keyhotels, index) => {
                            var str = self.props.users[key].modules[keyhotels].hotel_name;
                            var matches = str.match(/\b(\w)/g); 
                            var acronym = matches.join(''); 
            
                            return  (<span className="table-hotels" key={self.props.users[key].modules[keyhotels].hotel_id}>{acronym}</span>);
                        })} 
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                        <div className="action-elements">  
                        <a onClick={this.handleEditUser.bind(this,self.props.users[key]._id)} ><img className="action-element-icon" src="../../images/iconos/edit.svg" /></a>
                        {/* <img className="action-element-icon" src="../../images/iconos/cerrar.svg"/> */}
                    </div>
                    </td>
                </tr> 
            );
        })
    }

    render() {
        return (
            <section>
                
                <div className="head-content "> 
                    <div className="col-md-8 px-2">     
                        <h1>Configuration</h1>
                        <h2>USERS / ROLES</h2>
                    </div>
                    <div className="col-md-4 px-2 users-available">
                      <h3 className="color-blue min"><b>AVAILABLE USERS </b></h3>
                      <Icon className={this.state.showLoadingUsers} type="loading" />
                      <p className={"number-user "+ this.state.showUsers}>{this.state.used_users}/{this.state.total_user}</p>
                      <a className={this.state.add_user_enable} onClick={this.handleEditUser.bind(this,"")}><i className="fa  add-user">+</i></a>
                    </div>
                </div> 
                <div className="box regular col-md-12">
                   <h3 className="title-roles-h3"> <b>ACTIVE USERS</b>
                     {/* <input className="account-select top-form-select select-roles" placeholder="SEARCH" /> */}
                     {/* <i className="fa fa-search top-search"></i> */}
                     <button onClick={this.handleRefresUsers.bind(this,"")} className="button-refresh">REFRESH USER DATA</button>
                    </h3>
                    <table className="table-account-info">
                     <thead>
                          <tr className="tr-account-info">
                              <th>NAME</th>
                              <th>TYPE</th>
                              <th>ROLE</th>
                              <th>HOTELS</th>
                              <th>LAST ACCESS</th>
                              <th>LOGINS</th>
                              <th>ACTIONS</th>
                          </tr>
                     </thead>
                     <tbody className={this.state.showLoadingData}>
                        <tr><td><Icon className={this.state.showLoadingData} type="loading" /></td></tr>
                     </tbody>
                     <tbody className={this.state.showData}>
                        {this.renderUsers()}   
                    </tbody>        
                    </table>
                </div>
                <div className="col-md-12 container-img">
                    <div className="text-banner">
                        <span className="text-more-users">Do you need more users?</span>
                        <span className="text-price">Add more users from 15USD per month</span>
                    </div>
                    <button  onClick={this.handleEditUser.bind(this,"")} className="button-roles">ADD NEW USER</button>
                    <img className="image-add-user" src="../../images/banner-roles.png" />
                </div> 
            </section>
        )
    }

}

export default Roles


// WEBPACK FOOTER //
// ./src/Setup/modules/setup/views/corporative/Roles.js